import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getLogin, getResend } from "../../../service/AuthenticationService";
import { Button, Modal } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getVerification } from "../../../service/AuthenticationService";
import { getCmsList } from "../../../service/cms/cms";
import TranslateComponent from "../../components/TranslateComponent";

const Login = (props) => {
  const [content, setContent] = useState("");
  useEffect(() => {
    getCmsList("LANDING_PAGE")
      .then((res) => {
        //    console.log(res?.data?.data[0]?.text,"resData")
        setContent(res?.data?.data[0]?.text);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [token, setToken] = useState(queryParams.get("token"));

  const { logo } = props;

  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showpassword, setShowPassword] = useState(false);

  useEffect(() => {
    // console.log(queryParams.get("token"), "token")
    if (token) {
      getVerification(token, (res) => {
        // console.log(res)
        if (res.success === true) {
          // setAuthed({isAuth: true, token: res.data.token, user: userdata})
          toast.success(res.message);
        } else {
          // toast.error(res.message)
        }
      });
    }
  }, []);

  const onResend = () => {
    // console.log("yes");
    getResend(email);
    setShow(false);
    toast.success("Email verification link has been send successfully");
  };

  const formik = useFormik({
    initialValues: {
      // name: '',
      email: "",
      password: "",
    },
    validationSchema: yup.object({
      // name: yup.string().min(2, "name must have atleast 2 chracter").required(),
      email: yup.string().email().required(),
      password: yup
        .string()
        .min(6, "password must have atleast 6 chracter")
        .required(),
    }),
    // onSubmit: (values, {resetForm}) => {
    //   login(values);
    //   // toast.success("successfully");
    //     console.log(values);
    //     resetForm({values: ""})
    // }
    onSubmit: async (values) => {
      setEmail(values.email);
      // console.log(values, "vavava");
      try {
        await getLogin(values.email, values.password, (res) => {
          console.log("ress6555", res);
          if (res.success === true) {
            const userdata = {
              firstName: res.data.userProfile.firstName,
              lastName: res.data.userProfile.lastName,
              profilePic: res.data.userProfile.profilePic,
              id: res.data.userProfile.id,
              email: res.data.userProfile.email,
              phone: res.data.userProfile.phone,
              companyName: res.data.userProfile.companyName,
              companyWebsiteUrl: res.data.userProfile.companyWebsiteUrl,
              country: res.data.userProfile.country,
              countryCode: res.data.userProfile.countryCode,
              state: res.data.userProfile.state,
              stateCode: res.data.userProfile.stateCode,
              zipcode: res.data.userProfile.zipcode,
              city: res.data.userProfile.city,
              address: res.data.userProfile.address,
              role: res.data.userProfile.role,
              jobtitle: res.data.userProfile.jobTitle,
              jobRole: res?.data?.userProfile?.UserJobRole?.name,
              roleId: res?.data?.userProfile?.UserJobRole?.id,
              verified: res.data.userProfile.verified,
              status: res.data.userProfile.status,
              UserJobRole: res?.data?.userProfile?.UserJobRole,
              companyWebsiteUrl: res?.data?.userProfile?.companyWebsiteUrl,
              companyName: res?.data?.userProfile?.companyName,
              IndivisualModules: res?.data?.userProfile?.IndivisualModules,
              AssignRoleModules:
                res?.data?.userProfile?.UserJobRole?.name === "Individual users"
                  ? res?.data?.userProfile?.IndivisualModules?.split(",")
                      ?.map((item) => _TYPE_CHECK_INDIVISUL(item))
                      .flat()
                  : _TYPE_CHECK_INDIVISUL(
                      res?.data?.userProfile?.UserJobRole?.name
                    ),
            };
            // console.log(userdata,"userData")
            localStorage.setItem("gs3_AuthToken", res.data.accessToken);
            localStorage.setItem("gs3_User", JSON.stringify(userdata));
            const AssignRoleModules =
              res?.data?.userProfile?.UserJobRole?.AssignRoleModules?.map(
                (data) => data?.modulename
              );
            localStorage.setItem(
              "AssignRoleModules",
              JSON.stringify(AssignRoleModules)
            );
            // setAuthed({isAuth: true, token: res.data.token, user: userdata})
            toast.success(res.message);

            navigate("/dashboard");
            window.location.reload();
            // toast.success(res.message)

            formik.resetForm();
          } else if (
            res.message ===
            "Your account is not verified. Please check your email for the verification link."
          ) {
            // toast.error("happy")
            setShow(true);
            //  console.log(res);
          } else {
            toast.error(res.message);
          }
        });
      } catch (err) {
        toast.error(err?.response?.data?.message);
        console.log("err354", err);
      }
    },
  });

  const _TYPE_CHECK_INDIVISUL = (type) => {
    if (type === "Individual users") {
      return [];
    } else if (type === "Approver") {
      return [
        { modulename: "PastOrder Approved" },
        { modulename: "PastOrder Approved with Issues" },
        // {modulename:"Configuration"},
        // {modulename:"Invoices"},
        // {modulename:"Orders"},
        // {modulename:"Products"},
        // {modulename:"Suppliers"},
        // {modulename:"Reports"},
        // {modulename:"Dashboard"},
        // {modulename:"Business Unit"},
        // {modulename:"PastOrder Approved"},
        // {modulename:"PastOrder Approved with Issues"},
        // {modulename:"PastOrder Received"},
        // {modulename:"PastOrder Received with Issues"},
        // {modulename:"Department"},
        // {modulename:"Users"},
      ];
    } else if (type === "Receiver") {
      return [
        { modulename: "PastOrder Received" },
        { modulename: "PastOrder Received with Issues" },
        // {modulename:"Configuration"},
        // {modulename:"Invoices"},
        // {modulename:"Orders"},
        // {modulename:"Products"},
        // {modulename:"Suppliers"},
        // {modulename:"Reports"},
        // {modulename:"Dashboard"},
        // {modulename:"Business Unit"},
        // {modulename:"PastOrder Approved"},
        // {modulename:"PastOrder Approved with Issues"},
        // {modulename:"PastOrder Received"},
        // {modulename:"PastOrder Received with Issues"},
        // {modulename:"Department"},
        // {modulename:"Users"},
      ];
    } else if (type === "Department Manager") {
      return [
        // {modulename:"Configuration"},
        { modulename: "Invoices" },
        { modulename: "Orders" },
        // {modulename:"Products"},
        // {modulename:"Suppliers"},
        { modulename: "Reports" },
        // {modulename:"Dashboard"},
        // {modulename:"Business Unit"},
        // {modulename:"PastOrder Approved"},
        // {modulename:"PastOrder Approved with Issues"},
        // {modulename:"PastOrder Received"},
        // {modulename:"PastOrder Received with Issues"},
        // {modulename:"Department"},
        { modulename: "Users" },
      ];
    } else if (type === "Business Unit Manager") {
      return [
        // {modulename:"Configuration"},
        { modulename: "Invoices" },
        { modulename: "Orders" },
        // {modulename:"Products"},
        // {modulename:"Suppliers"},
        { modulename: "Reports" },
        // {modulename:"Dashboard"},
        { modulename: "Business Unit" },
        // {modulename:"PastOrder Approved"},
        // {modulename:"PastOrder Approved with Issues"},
        // {modulename:"PastOrder Received"},
        // {modulename:"PastOrder Received with Issues"},
        { modulename: "Department" },
        // {modulename:"Users"},
      ];
    } else if (type === "Suppliers+Products Manager") {
      return [
        // {modulename:"Configuration"},
        { modulename: "Invoices" },
        { modulename: "Orders" },
        { modulename: "Products" },
        { modulename: "Suppliers" },
        // {modulename:"Reports"},
        // {modulename:"Dashboard"},
        // {modulename:"Business Unit"},
        // {modulename:"PastOrder Approved"},
        // {modulename:"PastOrder Approved with Issues"},
        // {modulename:"PastOrder Received"},
        // {modulename:"PastOrder Received with Issues"},
        // {modulename:"Department"},
        // {modulename:"Users"},
      ];
    } else if (type === "Carbon Emission Manager") {
      return [
        // {modulename:"Configuration"},
        { modulename: "Invoices" },
        { modulename: "Orders" },
        { modulename: "Products" },
        { modulename: "Suppliers" },
        { modulename: "Reports" },
        // {modulename:"Dashboard"},
        // {modulename:"Business Unit"},
        // {modulename:"PastOrder Approved"},
        // {modulename:"PastOrder Approved with Issues"},
        // {modulename:"PastOrder Received"},
        // {modulename:"PastOrder Received with Issues"},
        // {modulename:"Department"},
        // {modulename:"Users"},
      ];
    } else if (type === "Account.+Finance Manager") {
      return [
        // {modulename:"Configuration"},
        { modulename: "Invoices" },
        { modulename: "Orders" },
        { modulename: "Products" },
        { modulename: "Suppliers" },
        { modulename: "Reports" },
        // {modulename:"Dashboard"},
        // {modulename:"Business Unit"},
        // {modulename:"PastOrder Approved"},
        // {modulename:"PastOrder Approved with Issues"},
        // {modulename:"PastOrder Received"},
        // {modulename:"PastOrder Received with Issues"},
        // {modulename:"Department"},
        // {modulename:"Users"},
      ];
    } else if (type === "VIRIDI Admin") {
      return [
        { modulename: "Configuration" },
        { modulename: "Invoices" },
        { modulename: "Orders" },
        { modulename: "Products" },
        { modulename: "Suppliers" },
        { modulename: "Reports" },
        { modulename: "Dashboard" },
        { modulename: "Business Unit" },
        { modulename: "PastOrder Approved" },
        { modulename: "PastOrder Approved with Issues" },
        { modulename: "PastOrder Received" },
        { modulename: "PastOrder Received with Issues" },
        { modulename: "Department" },
        { modulename: "Users" },
      ];
    }
    // else if(type==='Quality Manager'){
    //   return [
    //     {modulename:"Configuration"},
    //     {modulename:"Invoices"},
    //     {modulename:"Orders"},
    //     {modulename:"Products"},
    //     {modulename:"Suppliers"},
    //     {modulename:"Reports"},
    //     {modulename:"Dashboard"},
    //     {modulename:"Business Unit"},
    //     {modulename:"PastOrder Approved"},
    //     {modulename:"PastOrder Approved with Issues"},
    //     {modulename:"PastOrder Received"},
    //     {modulename:"PastOrder Received with Issues"},
    //     {modulename:"Department"},
    //     // {modulename:"Users"},
    //   ]

    // }
  };

  // const renderNameError = formik.touched.name && formik.errors.name && (<span style={{color: "red"}}>{formik.errors.name}</span>);

  const renderEmailError = formik.touched.email && formik.errors.email && (
    <span className="errorTxt">{formik.errors.email}</span>
  );

  const renderPasswordError = formik.touched.password &&
    formik.errors.password && (
      <span className="errorTxt">{formik.errors.password}</span>
    );

  // FOR-GET-LOGIN-RESPONSE
  const url = "https://reqres.in/api/users";

  const login = async (data) => {
    const response = await axios.post(url, data);
    // const getresponse =await axios.get(url)
    // console.log(getresponse, "getResponse")
    if ([200, 201, 202, 203, 204].includes(response.status)) {
      toast.success("Successfully");
    } else {
      toast.success("Error");
      console.log(response, "somnath");
    }
  };

  return (
    <>
      <div className="loginBg">
        <div className="container">
          <div className="row">
            {/* <div className="d-flex justify-content-end mb-5">
              <TranslateComponent />
            </div> */}
            <div className="col-lg-6 centerResp">
              <span className="logo">
                <img src={logo} alt="" />
              </span>
              <h2>Welcome!</h2>
              <div dangerouslySetInnerHTML={{ __html: content }} />
            </div>
            <div className="col-lg-6">
              <div className="loginBase loginDivmargin">
                <div className="text-center">
                  <h3>Ready to login</h3>
                  <h6 className="mb-3">
                    Enter your email address and password.
                  </h6>
                </div>
                {/* <form action="#" className='mb-5'>
                  <input type='email' className='form-control mb-3' placeholder='Email Address'/>
                  <input type='password' className='form-control mb-3' placeholder='password'/>
                  <div className="custom_radio mb-2">                  
                    <input type="radio" id="featured-1" name="featured" />
                    <label htmlFor="featured-1">Login as Customer</label><br/>
                    
                    <input type="radio" id="featured-2" name="featured" />
                    <label htmlFor="featured-2">Login as Employee</label>
                  </div>
                  <div className='loginBtn pt-3'>
                    <button type='submit' className='commonButton'>Next</button>
                    <a href=''>forgot password?</a>
                  </div>
                </form> */}

                <form onSubmit={formik.handleSubmit}>
                  {/* <div>
                    <label htmlFor="name">Name: </label>
                    <input type="text" id="name" name="name" onChange={formik.handleChange} value={formik.values.name} />
                    {renderNameError}
                  </div> */}

                  <div className="mb-4">
                    <label htmlFor="email">Email address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Email address"
                      onChange={formik.handleChange}
                      value={formik.values.email}
                    />
                    {renderEmailError}
                  </div>

                  <div className="mb-4">
                    <label htmlFor="password">Password</label>
                    <div className="showHide">
                      <input
                        className="form-control"
                        name="password"
                        type={showpassword ? "text" : "password"}
                        id="password"
                        placeholder="Password"
                        onChange={formik.handleChange}
                        value={formik.values.password}
                      />
                      <div
                        className="input-group-addon eyeAbs"
                        onClick={() => {
                          setShowPassword(!showpassword);
                        }}
                      >
                        {showpassword === true ? (
                          <span>
                            <i className="fa fa-eye" aria-hidden="true"></i>
                          </span>
                        ) : (
                          <span>
                            <i
                              className="fa fa-eye-slash"
                              aria-hidden="true"
                            ></i>
                          </span>
                        )}
                      </div>
                      {renderPasswordError}
                    </div>
                  </div>

                  <div className="loginBtn pt-1 mb-3">
                    <button type="submit" className="commonButton">
                      Login
                    </button>
                    <Link to="/forgotpassword">forgot password?</Link>
                  </div>
                </form>

                <h6>
                  Don't have an account?{" "}
                  <Link to="/register">Send us a Request</Link>
                </h6>
                {/* <div className="d-flex justify-content-end border-top pt-3">
                  <TranslateComponent />
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Verification Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6 style={{ color: "#D02B08" }}>
            Your account is not verified yet. Please resend verification link to
            your registered email address <span>{email}</span>
          </h6>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" className="commonButton" onClick={onResend}>
            Resend
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Login;
